"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var api_1 = require("../api/api");
var bet_validator_1 = require("../validators/bet-validator");
var actions_1 = require("../store/challenges/actions");
var actions_2 = require("../store/amount/actions");
var cookie_helper_1 = require("../helpers/cookie-helper");
var NewTicket = (function () {
    function NewTicket() {
        this.api = new api_1.default(window['API_URL'] + '/fast-coin');
    }
    NewTicket.prototype.buyTicketAdapter = function (store) {
        var sessionToken = window['customLoggedIn'] && window['customToken'] ?
            window['customToken'] : cookie_helper_1.default.get('token') != '' ?
            cookie_helper_1.default.get('token') : window['token'];
        this.api.send('/new-ticket', {
            sessionID: sessionToken,
            ticketAmount: store.getState().amount.MoneyValue,
            challengeCount: store.getState().challenge.nomber,
            playerName: store.getState().name.name
        }, function (response) {
            if ("Status" in response) {
                if (response.Status === 0) {
                    if ("ErrorText" in response) {
                        bet_validator_1.default.error(response.ErrorText);
                    }
                    else {
                        bet_validator_1.default.error("Error Buying Ticket");
                    }
                }
            }
            if ("TicketData" in response) {
                if ("FastCoinTicket" in response.TicketData) {
                    setTimeout(function () {
                        document.getElementById('buyTicketModal').classList.add('fade');
                        document.getElementById('modalOverlay').style.display = 'none';
                        document.getElementById('buyTicketModal').style.display = 'none';
                    }, 1400);
                    document.getElementById('buyTicketModal').classList.remove('fade');
                    document.getElementById('buyTicketModal').style.display = 'flex';
                    document.getElementById('modalOverlay').style.display = 'block';
                    document.getElementById('boughtTicketId').innerHTML =
                        'ID ' + response.TicketData.FastCoinTicket[0].TicketID;
                    store.dispatch(actions_2.resetAmount());
                    store.dispatch(actions_1.resetChallenge());
                    var amountElements = document.querySelectorAll('.ctrl-amount');
                    var challengeElems = document.querySelectorAll('.ctrl-no-of-chalenges');
                    Array.from(amountElements).forEach(function (element) {
                        if (element.classList.contains('active')) {
                            store.dispatch(actions_2.resetAmount());
                            element.classList.remove('active');
                        }
                    });
                    Array.from(challengeElems).forEach(function (element) {
                        if (element.classList.contains('active')) {
                            store.dispatch(actions_1.resetChallenge());
                            element.classList.remove('active');
                        }
                    });
                    document.getElementById('defaultChallenge').classList.add('active');
                    store.dispatch(actions_1.setChallenge({
                        nomber: 1
                    }));
                }
            }
        }, function (reject) {
            console.log('NewTicket failed.' + JSON.parse(reject));
        });
    };
    NewTicket.prototype.authenticate = function (store, autoName) {
        return __awaiter(this, void 0, void 0, function () {
            var language, error_1, amountElements, challengeElems, error_2, amountElements, challengeElems;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        language = window['lang'] === null ? 'en' : window['lang'];
                        if (!!window['token']) return [3, 9];
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 7];
                        if (!(window['customLoggedIn'] && window['customToken'])) return [3, 1];
                        autoName.setAutoName(store);
                        this.buyTicketAdapter(store);
                        return [3, 6];
                    case 1:
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4, this.getTokenPromise()];
                    case 3:
                        _a.sent();
                        return [3, 5];
                    case 4:
                        error_1 = _a.sent();
                        store.dispatch(actions_2.resetAmount());
                        store.dispatch(actions_1.resetChallenge());
                        amountElements = document.querySelectorAll('.ctrl-amount');
                        challengeElems = document.querySelectorAll('.ctrl-no-of-chalenges');
                        Array.from(amountElements).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_2.resetAmount());
                                element.classList.remove('active');
                            }
                        });
                        Array.from(challengeElems).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_1.resetChallenge());
                                element.classList.remove('active');
                            }
                        });
                        document.getElementById('defaultChallenge').classList.add('active');
                        store.dispatch(actions_1.setChallenge({
                            nomber: 1
                        }));
                        return [2];
                    case 5:
                        autoName.setAutoName(store);
                        this.buyTicketAdapter(store);
                        _a.label = 6;
                    case 6: return [3, 8];
                    case 7:
                        bet_validator_1.default.error(window['langArr'][language].please_login);
                        return [2];
                    case 8: return [3, 17];
                    case 9:
                        if (!/loginpopup=0/.test(window['location']['href'])) return [3, 16];
                        if (!(window['customLoggedIn'] && !window['customToken'])) return [3, 14];
                        window['parent'].postMessage(JSON.stringify({
                            source: "elbet-messages",
                            payload: { action: "loginRequired" }
                        }), '*');
                        _a.label = 10;
                    case 10:
                        _a.trys.push([10, 12, , 13]);
                        return [4, this.getTokenPromise()];
                    case 11:
                        _a.sent();
                        return [3, 13];
                    case 12:
                        error_2 = _a.sent();
                        store.dispatch(actions_2.resetAmount());
                        store.dispatch(actions_1.resetChallenge());
                        amountElements = document.querySelectorAll('.ctrl-amount');
                        challengeElems = document.querySelectorAll('.ctrl-no-of-chalenges');
                        Array.from(amountElements).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_2.resetAmount());
                                element.classList.remove('active');
                            }
                        });
                        Array.from(challengeElems).forEach(function (element) {
                            if (element.classList.contains('active')) {
                                store.dispatch(actions_1.resetChallenge());
                                element.classList.remove('active');
                            }
                        });
                        document.getElementById('defaultChallenge').classList.add('active');
                        store.dispatch(actions_1.setChallenge({
                            nomber: 1
                        }));
                        return [2];
                    case 13:
                        autoName.setAutoName(store);
                        this.buyTicketAdapter(store);
                        return [3, 15];
                    case 14:
                        autoName.setAutoName(store);
                        this.buyTicketAdapter(store);
                        _a.label = 15;
                    case 15: return [3, 17];
                    case 16:
                        autoName.setAutoName(store);
                        this.buyTicketAdapter(store);
                        _a.label = 17;
                    case 17: return [2];
                }
            });
        });
    };
    NewTicket.prototype.getTokenPromise = function () {
        var tokenPromise = new Promise(function (resolve, reject) {
            window.addEventListener("message", function (event) {
                try {
                    if (JSON.parse(event.data).payload.action == 'login') {
                        window['customLoggedIn'] = true;
                        if (!JSON.parse(event.data).payload.token) {
                            reject(new Error('Empty Token Recieved'));
                        }
                        window['customToken'] = JSON.parse(event.data).payload.token;
                        resolve(window['customToken']);
                    }
                }
                catch (error) {
                    reject(error);
                }
            }, false);
            window['customToken'] ? resolve(window['customToken']) : '';
        });
        return tokenPromise;
    };
    return NewTicket;
}());
exports.default = NewTicket;



//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/ts/new-ticket/new-ticket.ts
// module id = 2401
// module chunks = 5